import React, { Component } from 'react';
import { Form, Input, message, Modal, Row, Select } from 'antd';
import { connect } from 'react-redux';

import { querySaveApplyContract } from '@api/xxcrm/contract';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contract_type: this.props.contract_type,
      account_info: this.props.account_info || {},
    };
  }

  componentDidMount() {}

  submit = () => {
    const data = this.props.form.getFieldsValue();
    const { account_info: accountInfo } = this.state;
    data.orgUuid = accountInfo.orgUuid;
    data.userUuid = accountInfo.userUuid;
    this.props.form.validateFields(err => {
      if (!err) {
        if (data.number > 10) {
          message.error('最多只能申请10份合同！');
          return;
        }
        querySaveApplyContract(data).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.props.cancel();
            this.props.loadDate();
          } else {
            message.error(res.message);
          }
        });
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const { contract_type: contractType, account_info: accountInfo } = this.state;
    return (
      <Modal
        title="合同申请"
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem {...formItemLayout} label="部门">
              <p>{accountInfo.orgName}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem {...formItemLayout} label="姓名">
              <p>{accountInfo.userName}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem {...formItemLayout} label="合同类型">
              {getFieldDecorator('type', {
                rules: [{ required: true, message: '合同类型不能为空！' }],
              })(
                <Select>
                  {contractType.map(item => {
                    return <Option key={item.value}>{item.key}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row>
            <FormItem {...formItemLayout} label="合同份数">
              {getFieldDecorator('number', {
                rules: [{ required: true, message: '合同份数不能为空！' }],
              })(<Input type="number" />)}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalApply.js